import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./ProductDetails.css";
import BaseButton from "../Common/BaseButton";
import Button from 'react-bootstrap/Button';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useProductContext } from "../Context/ProductContext";

const ProductDosage = (props) => {
  const { dosage, handleProductRegenerate, previewMode, loading, initialSku, keywords: propKeywords, handleManualEdit, onHide, sectionId, sectionTitle, isHidden, onUnhide } = props;
  const location = useLocation();
  const keywords = propKeywords || location.state?.keywords || [];
  const [isEditing, setIsEditing] = useState(false);
  const [previousResponse, setPreviousResponse] = useState("");
  const { updateProductData } = useProductContext();

  const convertDosageToString = (dosageData) => {
    if (!dosageData) return "";
    if (typeof dosageData === "string") return dosageData;
    if (Array.isArray(dosageData)) {
      return dosageData.map(item =>
        typeof item === "string" ? item : JSON.stringify(item)
      ).join("\n");
    }
    return Object.entries(dosageData)
      .map(([key, value]) => `${key}: ${value}`)
      .join("\n");
  };

  const [dosageText, setDosageText] = useState(convertDosageToString(dosage));

  useEffect(() => {
    const dosageString = convertDosageToString(dosage);
    setDosageText(dosageString);
    if (dosageString.trim()) {
      setPreviousResponse(dosageString);
    }
  }, [dosage]);

  const toggleEdit = () => {
    if (isEditing) {
      // Save the updated dosage when exiting edit mode
      const updatedData = {
        dosage: dosageText
      };
      updateProductData(initialSku, "dosage", updatedData);
    }
    setIsEditing(!isEditing);
  };

    const handleDoneClick = () => {
    setIsEditing(false);
    handleManualEdit("dosage", dosageText);
  };

  const handleRegenerate = async (type, formData, dosage) => {
    let furtherDetailsToSend = "";
    let customPromptToSend = null;

    if (typeof formData === "object" && formData !== null) {
      if (formData.reason?.trim()) {
        furtherDetailsToSend = formData.reason;
      } else {
        customPromptToSend = {
          goal: formData.goal,
          role: formData.role,
          constraints: formData.constraints,
        };
      }
    }
    else if (typeof formData === "string") {
      furtherDetailsToSend = formData;
    }

    await handleProductRegenerate(type, furtherDetailsToSend, dosage, customPromptToSend, previousResponse, keywords);
  };

  const getDisplayText = () => {
    const text = convertDosageToString(dosage);
    return text || dosageText;
  };


  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">Dosage</div>
        {!previewMode && (
          isEditing ? (
            <Button variant="dark" onClick={handleDoneClick}>Done</Button>
          ) : (
            <div className="button-group">
              <BaseButton
                className="outlineprimary"
                children="Regenerate Text"
                imageSrc="/regenerate-text.svg"
                isModalOpen={true}
                handleClick={(formData) => handleRegenerate("dosage", formData, dosage)}
              />
              {isHidden && onUnhide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Unhide Section"
                  handleClick={onUnhide}
                />
              ) : onHide ? (
                <BaseButton
                  className="outlineprimary"
                  children="Hide Section"
                  handleClick={() => onHide(sectionId, sectionTitle)}
                />
              ) : null}
              <BaseButton
                className="outlineprimary btn-sm"
                children="Edit Text"
                imageSrc="/edit-text.svg"
                handleClick={toggleEdit}
              />
            </div>
          )
        )}
      </div>

      <div className="">
        {loading ? (
          <Skeleton height={12} width="90%" style={{ marginBottom: 5 }} count={5} />
        ) : isEditing ? (
          <textarea
            value={dosageText}
            onChange={(e) => setDosageText(e.target.value)}
            className="product-description-input form-control"
          />
        ) : (
          <div className="description-tabs">
            <ul className="mb-0">
              {getDisplayText()
                .split("\n")
                .filter(line => line.trim() !== "")
                .map((line, index) => (
                  <li className="productDescription" key={index}>{line}</li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDosage;
